import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const News = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const newsItems = [
    {
      id: 1,
      title: 'Enterprise Risk Management & Cyber Resilience',
      date: 'March 29, 2026',
      excerpt: 'Reflected on Enterprise Risk Management following a session at USIU-Africa. Explored how cybersecurity moves beyond reducing risk to deliberately designing for resilience across systems, processes, and people.',
      image: require('../../assets/risk.jpg'),
      category: 'Insight',
      linkedinUrl: 'https://www.linkedin.com/posts/gerald-suleh_riskmanagement-cybersecurity-cyberresilience-activity-7444111455844712448-uIkn',
    },
    {
      id: 2,
      title: 'Afretec Makerthon Mentorship',
      date: 'March 13, 2026',
      excerpt: 'Mentored teams at the Afretec Makerthon, guiding practical applications of blockchain for financial inclusion and real-world problem solving across emerging African tech ecosystems.',
      image: require('../../assets/makerthon.jpg'),
      category: 'Mentorship',
      linkedinUrl: 'https://www.linkedin.com/posts/gerald-suleh_makerthons-afretec-makerthon-activity-7438283257118498816-d8Ug',
    },
    {
      id: 3,
      title: 'CISO Summit by CIO Africa',
      date: 'March 11, 2026',
      excerpt: 'Attended the CISO Summit, exploring evolving cyber threats, AI-driven attacks, and the growing importance of collaboration across academia, industry, and government for resilience.',
      image: require('../../assets/news/cio.jpg'),
      category: 'Conference',
      linkedinUrl: 'https://www.linkedin.com/posts/gerald-suleh_cybersecurity-dx5-cisosummit-activity-7437532240156200961-H7V4',
    },
    {
      id: 4,
      title: 'IXP Management & Network Design Certification',
      date: 'February 7, 2026',
      excerpt: 'Completed the Internet Society course on IXP Management and Network Design, strengthening understanding of Internet infrastructure and its role in resilience and affordability.',
      image: require('../../assets/CybersecurityCapacityBuilding.jpg'),
      category: 'Certification',
      linkedinUrl: 'https://www.linkedin.com/posts/gerald-suleh_ixp-management-network-design-gerald-suleh-activity-7425999794096979969-7o5P',
    },
    {
      id: 5,
      title: 'Year-End Reflection Through Art',
      date: 'December 31, 2025',
      excerpt: 'Closed the year with a personal reflection on growth and creativity, reconnecting with art as a form of expression beyond technology and cybersecurity.',
      image: require('../../assets/news/luffy.jpg'),
      category: 'Personal',
      linkedinUrl: 'https://www.linkedin.com/posts/gerald-suleh_art-expression-reflection-activity-7412098034961956864-vVc6',
    },
    {
      id: 6,
      title: 'Strathmore University Cybersecurity Panel',
      date: 'November 8, 2025',
      excerpt: 'Spoke at Strathmore University on cybersecurity trends, covering topics like HSTS, passphrases, cloud security, and the strategic role of GRC in strengthening real-world security practices.',
      image: require('../../assets/gdgoncampus.jpg'),
      category: 'Conference',
      linkedinUrl: 'https://www.linkedin.com/posts/gerald-suleh_cybersecurity-strathmoreuniversity-techtalk-activity-7392917283506925569-iGB2',
    },
    {
      id: 7,
      title: 'CodeAfrica 2.0 Conference Panel Moderation',
      date: 'May 23, 2025',
      excerpt: 'Moderated a panel on securing emerging technologies, bringing together experts to discuss cybersecurity challenges across AI, blockchain, and developer ecosystems.',
      image: require('../../assets/news/codeafrica.jpg'),
      category: 'Conference',
      linkedinUrl: 'https://www.linkedin.com/posts/gerald-suleh_codeafrica2025-cybersecurity-blockchain-activity-7332683147035201537-jtjg',
    },
    {
      id: 8,
      title: 'KIPPRA Regional Conference Panel on Emerging Tech',
      date: 'May 21, 2025',
      excerpt: 'Spoke on securing emerging technologies at the KIPPRA Regional Conference, sharing insights on blockchain applications and digital health innovation.',
      image: require('../../assets/news/kipra.jpg'),
      category: 'Conference',
      linkedinUrl: 'https://www.linkedin.com/posts/gerald-suleh_techforgood-responsibleinnovation-blockchainforimpact-activity-7331028951835873280-_678',
    },
    {
      id: 9,
      title: 'AACOSE Youth Innovation Pitch Competition',
      date: 'May 14, 2025',
      excerpt: 'Secured third place at AACOSE, supporting youth-driven innovation that transforms waste into products while creating income opportunities in Pangani.',
      image: require('../../assets/news/aacose.jpg'),
      category: 'Achievement',
      linkedinUrl: 'https://www.linkedin.com/posts/gerald-suleh_aacose-namalkia-youthinnovation-activity-7328880010323300354-IH-0',
    },
    {
      id: 10,
      title: 'Tree Growing Initiative at Pangani Primary School',
      date: 'April 22, 2025',
      excerpt: 'Led a community tree-growing initiative during Earth Day, bringing together students, local government, and community members to plant 300 fruit trees.',
      image: require('../../assets/news/treegrowing.png'),
      category: 'Community',
      linkedinUrl: 'https://www.linkedin.com/posts/gerald-suleh_internationalearthday-namalkia-panganiprimary-activity-7321518513125240832-UqJ1',
    },
  ];

  return (
    <section ref={ref} className="py-20 bg-white dark:bg-secondary-900">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="mb-12 text-center"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 dark:text-white mb-4">
            Latest News & Updates
          </h2>
          <p className="text-secondary-600 dark:text-secondary-300 max-w-2xl mx-auto">
            Stay informed about my recent activities, achievements, and upcoming events.
          </p>
          <div className="w-20 h-1 bg-primary-600 mx-auto mt-4"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {newsItems.map((item, index) => (
            <motion.article
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 + index * 0.1 }}
              className="bg-secondary-50 dark:bg-secondary-800 rounded-lg overflow-hidden shadow-custom"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={item.image} 
                  alt={item.title} 
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                />
                <div className="absolute top-4 left-4 bg-primary-600 text-white text-xs font-bold uppercase tracking-wider py-1 px-2 rounded">
                  {item.category}
                </div>
              </div>
              
              <div className="p-6">
                <time className="text-sm text-secondary-500 dark:text-secondary-400">
                  {item.date}
                </time>
                <h3 className="text-xl font-bold text-secondary-800 dark:text-white mt-2 mb-3">
                  {item.title}
                </h3>
                <p className="text-secondary-600 dark:text-secondary-300 mb-4">
                  {item.excerpt}
                </p>
                <a 
                  href={item.linkedinUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-primary-600 dark:text-primary-400 hover:text-primary-800 dark:hover:text-primary-300 font-medium"
                >
                  Read More
                  <svg className="ml-2 w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </a>
              </div>
            </motion.article>
          ))}
        </div>

        {/* Portfolio Navigation CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-16 text-center"
        >
          <p className="text-secondary-600 dark:text-secondary-300 mb-6 text-lg">
            Explore the work behind the headlines:
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/portfolio"
              state={{ category: 'technical' }}
              className="bg-primary-600 hover:bg-primary-700 dark:bg-primary-700 dark:hover:bg-primary-600 text-white px-8 py-3 rounded-md transition-colors duration-300 font-medium"
            >
              View Technical Projects
            </Link>
            <Link
              to="/portfolio"
              state={{ category: 'community' }}
              className="bg-transparent border-2 border-primary-600 hover:bg-primary-600 hover:text-white text-primary-600 dark:text-primary-400 dark:border-primary-400 dark:hover:bg-primary-700 dark:hover:text-white px-8 py-3 rounded-md transition-colors duration-300 font-medium"
            >
              Community Impact
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default News;

